module.exports = __webpack_public_path__ + "static/media/jin.c10337c1.jpeg";